import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseGetInfiniteQueryData = (wrapperOptions) => {
    const useGetInfiniteQueryData = () => {
        const queryClient = useQueryClient();
        const queryKey = getQueryBaseKey(wrapperOptions, 'infiniteQuery');
        const getQueryData = () => {
            const foundQuery = queryClient.getQueriesData({
                queryKey,
                exact: false,
            });
            const firstQueryMatch = foundQuery[0];
            if (!firstQueryMatch)
                return undefined;
            const [, firstQuery] = firstQueryMatch;
            return firstQuery;
        };
        return getQueryData;
    };
    return useGetInfiniteQueryData;
};
